import { Span } from "@goodfill/ui-components";

export const FallbackUI = ({ text }: { text: string }) => {
  return (
    <div className="flex flex-col grow justify-center my-3 md:my-6 mx-3 md:mx-6">
      <Span red={true} size="lg">
        {text}
      </Span>
    </div>
  );
};
